export const heroQuickCards = [
  {
    id: "q1",
    icon: "ri-map-pin-2-line",
    title: "最新入口速查",
    desc: "按更新时间列出当前可用线路，优先展示延迟低的地址。",
    tag: "已更新",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20map%20pins%20on%20soft%20cream%20paper%20background%2C%20clean%20line%20style%2C%20orange%20accent%2C%20flat%20illustration%2C%20tool%20interface%20aesthetic&width=640&height=420&seq=91hero-card-1&orientation=landscape",
  },
  {
    id: "q2",
    icon: "ri-error-warning-line",
    title: "打不开怎么办",
    desc: "三步排查：换网络、清缓存、对时间，多数问题当场解决。",
    tag: "高频",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20broken%20link%20warning%20icon%20on%20soft%20cream%20paper%20background%2C%20clean%20line%20style%2C%20amber%20accent%2C%20flat%20illustration&width=640&height=420&seq=91hero-card-2&orientation=landscape",
  },
  {
    id: "q3",
    icon: "ri-bookmark-3-line",
    title: "长期收藏方法",
    desc: "别再存单条链接，学会用固定入口规避地址更换。",
    tag: "必看",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20bookmark%20saved%20folder%20illustration%20on%20soft%20cream%20paper%20background%2C%20clean%20line%20style%2C%20green%20accent%2C%20flat%20design&width=640&height=420&seq=91hero-card-3&orientation=landscape",
  },
  {
    id: "q4",
    icon: "ri-shield-check-line",
    title: "安全访问提醒",
    desc: "识别仿冒页面，认准本页汇总的官方口径再进入。",
    tag: "安全",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20shield%20checkmark%20protection%20illustration%20on%20soft%20cream%20paper%20background%2C%20clean%20line%20style%2C%20olive%20accent%2C%20flat%20design&width=640&height=420&seq=91hero-card-4&orientation=landscape",
  },
];

export const entryList = [
  {
    id: "e1",
    name: "主线路入口",
    summary: "默认推荐线路，日常访问首选，更新后一般最先恢复。",
    status: "运行中",
    latency: "低延迟",
    updated: "10 分钟前",
  },
  {
    id: "e2",
    name: "备用线路一",
    summary: "主线路拥堵或打不开时切换，兼容移动端网络。",
    status: "运行中",
    latency: "中延迟",
    updated: "25 分钟前",
  },
  {
    id: "e3",
    name: "备用线路二",
    summary: "面向部分地区的加速线路，跨网访问更稳定。",
    status: "运行中",
    latency: "低延迟",
    updated: "40 分钟前",
  },
  {
    id: "e4",
    name: "镜像地址",
    summary: "内容一致的镜像页面，适合主线路被拦截时使用。",
    status: "维护中",
    latency: "待恢复",
    updated: "1 小时前",
  },
  {
    id: "e5",
    name: "移动端专用入口",
    summary: "针对手机浏览器优化，减少跳转与弹窗干扰。",
    status: "运行中",
    latency: "低延迟",
    updated: "2 小时前",
  },
  {
    id: "e6",
    name: "旧地址回退页",
    summary: "收录历史常用地址，便于找回曾经收藏的链接。",
    status: "运行中",
    latency: "中延迟",
    updated: "3 小时前",
  },
];

export const troubleshootSteps = [
  {
    id: "t1",
    step: "01",
    title: "先换一个网络环境",
    desc: "切换 Wi-Fi 与移动数据，或在浏览器开启无痕模式，排除本地网络对域名的限制。",
  },
  {
    id: "t2",
    step: "02",
    title: "清理缓存与 DNS",
    desc: "清除浏览器缓存与 Cookie，并切换 DNS（如公共 DNS），让解析指向最新地址。",
  },
  {
    id: "t3",
    step: "03",
    title: "核对设备时间与系统版本",
    desc: "系统时间和浏览器版本过旧也会导致证书报错，先同步时间再更新浏览器。",
  },
  {
    id: "t4",
    step: "04",
    title: "改用备用线路",
    desc: "主线路维护期间，直接切换到本页列出的备用或镜像地址，避免反复刷新。",
  },
  {
    id: "t5",
    step: "05",
    title: "仍无法打开时回本页",
    desc: "收藏本页作为固定入口，地址变化会在这里统一更新，不必再四处寻找。",
  },
];

export const trustItems = [
  {
    id: "tr1",
    icon: "ri-refresh-line",
    title: "地址集中更新",
    desc: "入口变动后统一在本页刷新，减少在陌生站点间来回试错。",
  },
  {
    id: "tr2",
    icon: "ri-fingerprint-line",
    title: "认准官方口径",
    desc: "仅整理公开的官方入口信息，不收录第三方诱导跳转页面。",
  },
  {
    id: "tr3",
    icon: "ri-eye-off-line",
    title: "不索取任何信息",
    desc: "本页仅做入口指引，不需要登录、下载或填写任何表单。",
  },
  {
    id: "tr4",
    icon: "ri-time-line",
    title: "更新频率固定",
    desc: "按固定时段巡检各线路状态，标注可用与维护情况。",
  },
];

export const collectGuide = [
  {
    id: "c1",
    title: "收藏本页而不是单条链接",
    desc: "单条地址随时可能更换，本页作为固定入口会持续同步最新结果。",
  },
  {
    id: "c2",
    title: "保存到浏览器书签栏",
    desc: "在书签栏固定本页，一键回到入口汇总，无需重新搜索。",
  },
  {
    id: "c3",
    title: "记下本页更新时间",
    desc: "每次访问先看更新时间与线路状态，避免使用过期的旧地址。",
  },
  {
    id: "c4",
    title: "多设备各存一份",
    desc: "手机与电脑分别收藏，换设备时也能第一时间找回入口。",
  },
];

export const faqList = [
  {
    id: "f1",
    q: "91网入口怎么找最靠谱？",
    a: "优先使用本页汇总的入口列表，按更新时间浏览即可。入口变动会在这里统一更新，避免在搜索结果里点到仿冒或过期页面。",
  },
  {
    id: "f2",
    q: "官网网址打不开是什么原因？",
    a: "常见原因有本地网络限制、DNS 缓存过期、浏览器版本过旧或线路临时维护。按本页的排查步骤逐一处理，多数情况可当场恢复。",
  },
  {
    id: "f3",
    q: "最新地址多久更新一次？",
    a: "地址与线路状态按固定时段巡检更新，页面会显示最近更新时间。如遇大规模调整，也会尽快补充新的可用入口。",
  },
  {
    id: "f4",
    q: "为什么建议收藏本页而不是单条链接？",
    a: "单条链接可能随线路调整失效，而本页作为固定入口会持续同步最新结果，收藏一次即可长期使用。",
  },
  {
    id: "f5",
    q: "访问本页需要注册或下载吗？",
    a: "不需要。本页只做入口汇总与指引，不涉及注册、登录、下载或填写任何资料，直接在浏览器打开即可浏览。",
  },
  {
    id: "f6",
    q: "打开后页面样式错乱怎么办？",
    a: "先强制刷新页面并清除缓存，或换用较新版本的浏览器。若仍异常，可尝试切换另一条线路入口重新加载。",
  },
];

export const updateLog = [
  { id: "u1", text: "主线路入口完成例行巡检，状态正常。", time: "10 分钟前" },
  { id: "u2", text: "备用线路一同步最新可用地址。", time: "25 分钟前" },
  { id: "u3", text: "镜像地址进入维护，预计稍后恢复。", time: "1 小时前" },
  { id: "u4", text: "移动端专用入口调整跳转逻辑。", time: "2 小时前" },
];